import React from 'react';
import PropTypes from 'prop-types';
import useProvideNotification from 'hooks/useProvideNotification';
import NotificationContext from 'context/NotificationContext';

export function NotificationProvider({ children }) {
  const notification = useProvideNotification();
  return (
    <NotificationContext.Provider value={notification}>
      {children}
    </NotificationContext.Provider>
  );
}

NotificationProvider.propTypes = {
  children: PropTypes.node,
};

export default NotificationProvider;
